// extracted by mini-css-extract-plugin
export default {"container":"SearchBox_container__aYsHY","input":"SearchBox_input__+nuoc"};